import { Button, Grid, Typography } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const WelcomeIntro360 = ({mainImage,introText,slug,blocks,changeTab,setCurrentBlock}) => {

    const handleClick = ()=>{
        setCurrentBlock(blocks[slug.pos])
        changeTab(1);
    }

    return (
        <Grid container spacing={4} sx={{marginTop:"16px"}} alignItems="flex-start">
            <Grid size={7}>
                <Typography variant="body1" color="secondary" fontWeight={400} sx={{lineHeight:"1.7",fontSize:"1.05rem"}} dangerouslySetInnerHTML={{ __html: introText }}/>
                <Button onClick={handleClick} variant="contained" endIcon={<ArrowForwardIcon/>} sx={{marginTop:"24px",color:"white"}}>
                {
                    slug?.pos === 0 ? "START" : "CONTINUE"
                }
                </Button>
            </Grid>
            <Grid size={5} display="flex" justifyContent="center" sx={{marginTop:"-48px"}}>
                <img className="assesmentMainImageBig" src={mainImage} alt="Assessment Logo"/>
            </Grid>
        </Grid>
      )
}

export default WelcomeIntro360